import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';

export default function ActionButton(props) {
  const { options, isDisabled } = props;
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  let primaryAction = options[0];
  let dropDownActions = options.slice(1, options.length);

  const handleClick = (option) => {
    const [actionType, actionData] = option.action;

    if (actionType === 'GO') {
      history.push(actionData);
      handleToggle();
      return;
    }

    if (actionType === 'ACTION') {
      actionData();
      if (!option.hasModal) {
        handleToggle();
      }
      return;
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  if (options.length === 0) {
    return null;
  }

  return (
    <>
      <ButtonGroup
        variant="contained"
        color="primary"
        ref={anchorRef}
        aria-label="split button"
        disabled={isDisabled}
      >
        {primaryAction.tooltipTitle ? (
          <Tooltip
            title={primaryAction.tooltipTitle}
            placement={primaryAction.tooltipPlacement}
          >
            <span>
              <Button
                onClick={() => handleClick(primaryAction)}
                disabled={primaryAction.isDisabled}
                color="primary"
                variant="contained"
              >
                {primaryAction.name}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            onClick={() => handleClick(primaryAction)}
            disabled={primaryAction.isDisabled}
          >
            {primaryAction.name}
          </Button>
        )}
        {dropDownActions.length === 0 ? null : (
          <Button
            color="primary"
            variant="contained"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
            disabled={dropDownActions.every((i) => i.isDisabled)}
          >
            {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </Button>
        )}
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {dropDownActions.map((option, index) =>
                    option.isDisabled ? (
                      <Tooltip
                        key={option.name + index}
                        title={option.tooltipTitle}
                        placement={option.tooltipPlacement}
                      >
                        <span>
                          <MenuItem
                            disabled={option.isDisabled}
                            key={option.name}
                            onClick={(event) => handleClick(option)}
                          >
                            {option.name}
                          </MenuItem>
                        </span>
                      </Tooltip>
                    ) : (
                      <MenuItem
                        key={option.name}
                        onClick={(event) => handleClick(option)}
                      >
                        {option.name}
                      </MenuItem>
                    )
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
